import styles from "./DigitalSignature.module.scss";
import { Typography } from 'seagull';
import React from 'react';
function DigitalSignature(_ref) {
  let {
    formattedDigitalSignature
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    className: styles.digitalSignature,
    "data-testid": "digital-signature-block"
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.detailsWrapper
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "paragraph2",
    skin: "secondary",
    "data-testid": "digital-signature-block-when"
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.signedSignature,
    "data-testid": "digital-signature-block-signature"
  }, formattedDigitalSignature.signature), ' ', formattedDigitalSignature.on, " ", formattedDigitalSignature.ip)));
}
export default DigitalSignature;